import '../accordion/jquery.accordion';
import '../accordion/jquery.accordion.scss';



// WEBPACK FOOTER //
// ./src/lib/accordion.js